import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "case container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "case__title title" }, "Кейсы", -1)
const _hoisted_3 = {
  key: 0,
  class: "case__list"
}
const _hoisted_4 = ["index"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { href: "#" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Читать кейс ")
const _hoisted_9 = { class: "case__item block" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["id"]
const _hoisted_12 = { href: "#" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Читать кейс ")
const _hoisted_14 = ["src"]

import { onMounted, computed } from 'vue'
import { IMAGE_BASE_URL } from '@/config'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination } from 'vue3-carousel'
import { store } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'CaseSect',
  setup(__props) {

const itemsToShow = computed(() => (store.isMobile ? 1.3 : 2))

let id = 0

const data = [
  {
    title: 'Автоматизация диджитал&#8209;агентства',
    img: 'case-1.png'
  },
  {
    title: 'Приём платежей в&nbsp;рекламной медиа&#8209;группе',
    img: 'case-2.png'
  },
  {
    title: 'Оптимизация бухгалтерии в&nbsp;производственной компании',
    img: 'case-2.png'
  }
].map((item) => {
  id++

  return {
    ...item,
    id: `case-title-${id}`
  }
})

const fillTitle = () => {
  data.forEach((item) => {
    const element = document.getElementById(item.id)
    if (element) {
      element.innerHTML = item.title
    }
  })
}

onMounted(() => fillTitle())

window.addEventListener('resize', () => fillTitle())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    (_unref(store).isDesktop)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              index: index,
              class: "case__item block"
            }, [
              _createElementVNode("img", {
                src: _unref(IMAGE_BASE_URL) + item.img,
                alt: ""
              }, null, 8, _hoisted_5),
              _createElementVNode("h3", {
                class: "block__title",
                id: item.id
              }, null, 8, _hoisted_6),
              _createElementVNode("a", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", {
                  style: _normalizeStyle(`background: no-repeat center / contain url(${_unref(IMAGE_BASE_URL)}arrow.svg)`)
                }, null, 4)
              ])
            ], 8, _hoisted_4))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_unref(Carousel), {
          key: 1,
          "items-to-show": _unref(itemsToShow)
        }, {
          addons: _withCtx(() => [
            _createVNode(_unref(Pagination))
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
              return (_openBlock(), _createBlock(_unref(Slide), {
                key: index,
                index: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: _unref(IMAGE_BASE_URL) + item.img,
                      alt: ""
                    }, null, 8, _hoisted_10),
                    _createElementVNode("h3", {
                      class: "block__title",
                      id: item.id
                    }, null, 8, _hoisted_11),
                    _createElementVNode("a", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", {
                        style: _normalizeStyle(`background: no-repeat center / contain url(${_unref(IMAGE_BASE_URL)}arrow.svg)`)
                      }, null, 4)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["items-to-show"])),
    _createElementVNode("img", {
      class: "case__dec",
      src: _unref(IMAGE_BASE_URL) + 'case-lines.png',
      alt: ""
    }, null, 8, _hoisted_14)
  ]))
}
}

})